// @flow

import React from 'react';
import trim from 'lodash/fp/trim';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';

import Error from './Error';
import Counter from '../Countdown/Counter';

type Props = {
  l10n: L10n,
  endDate: string,
  onSearchParticipant: ({ registrationNumber: string }) => void,
}

type State = {
  searchText: string,
  error: string,
}

const ENTER_KEY = 13;
const ERROR_REG_NUMBER_REQUIRED = 'page.event.virtualEvent.submitResult.search.error';

export const SearchComponent = class Search extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      searchText: '',
      error: '',
    };
  }

  onChangeSearchText = (e: { target: { value: string } }) => {
    const searchText = trim(e.target.value);
    if (/^[a-zA-Z0-9-]{0,50}$/g.test(searchText)) {
      this.setState({ searchText });
    }
    this.setState({ error: '' });
  }

  onSearch = () => {
    const { searchText } = this.state;
    const { onSearchParticipant } = this.props;
    if (searchText) {
      onSearchParticipant({ registrationNumber: searchText });
    } else {
      this.setState({ error: ERROR_REG_NUMBER_REQUIRED });
    }
  }

  onSearchInputKeyDown = ({ keyCode }: { keyCode: number }) => {
    if (keyCode === ENTER_KEY) {
      this.onSearch();
    }
  }

  render() {
    const {
      l10n: { formatMessage },
      endDate,
    } = this.props;

    const { searchText, error } = this.state;
    return (
      <div className="virtual-event__submit-result__search container">
        <div className="virtual-event__submit-result__search__title">
          <L10nMessage id="page.event.virtualEvent.submitResult.search.title" />
        </div>
        <div className="virtual-event__submit-result__search__subtitle">
          <L10nMessage id="page.event.virtualEvent.submitResult.search.subtitle" />
        </div>
        <Counter
          onTimeUp={() => { window.location.reload(); }}
          className="virtual-event__submit-result__search__counter"
          dateToCompare={new Date(endDate).getTime()} />
        <div className="virtual-event__submit-result__search__search-field">
          <div className="virtual-event__submit-result__search__search-field__label">
            <L10nMessage id="page.event.virtualEvent.submitResult.search.label.registrationId" />
          </div>
          <div className="search-box search-box--lg">
            <div className="search-box__input-addon-group">
              <input
                className="input"
                type="search"
                placeholder={formatMessage('page.event.virtualEvent.submitResult.search.input.placeholder.content')}
                onKeyDown={this.onSearchInputKeyDown}
                onChange={this.onChangeSearchText}
                value={searchText} />
            </div>
            <button
              type="button"
              onClick={this.onSearch}
              className="btn btn-primary">
              {formatMessage('page.event.virtualEvent.submitResult.search.button.text')}
            </button>
          </div>
          {error && (<Error message={formatMessage(error)} />)}
        </div>
      </div>
    );
  }
};

export default injectL10n()(SearchComponent);
